// open modal by id
function openModal(id) {
  document.getElementById(id).classList.add("open");
  document.body.classList.add("jw-modal-open");
}

// close currently open modal
function closeModal() {
  document.querySelector(".jw-modal.open").classList.remove("open");
  document.body.classList.remove("jw-modal-open");
}

function closeNewsletterTrigger() {
  document
    .querySelector("#jw-newsletter-modal-trigger")
    .classList.remove("open");
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

window.addEventListener("load", function () {
  // close modals on background click
  document.addEventListener("click", (event) => {
    if (event.target.classList.contains("jw-modal")) {
      closeModal();
    }
  });

  // 2025-02-14 - Disable Newsletter signup popup on timer
  // set timer for displaying popup
  // setTimeout(function () {
  //   openModal('jw-newsletter-modal');
  // }, 30000 /*30,000*/);

  // 2025-03-24 - Display brown banner on timer to launch newsletter popup
  setTimeout(function () {
    // 2025-03-29 - only display if user is on home page and quickly
    if(window.location.pathname === "/") {
       document
      .getElementById("jw-newsletter-modal-trigger")
      .classList.add("open");
    }
   
  }, 3000 /* 3 seconds */); 
});
